import '../../@types';
import { isProductEnv } from './env';
import { loadScript } from './loader';
import { getQueryParam } from './tools';

export enum Debug {
    AUTO = 'auto',
    TRUE = 1,
    FALSE = 0,
}

/** 开启 eruda 调试工具 */
export function enableDebug(ok: Debug = Debug.AUTO): void {
    if (typeof eruda !== 'undefined') return; // 已加载过 eruda
    if (ok === Debug.FALSE) return;
    if (ok === Debug.AUTO) {
        if (isProductEnv() && getQueryParam('__test') !== '1') return; // 生产环境不允许自动开启 DEBUG
        // 自动开启 DEBUG
    }
    // 开启 DEBUG
    // document.writeln('<script src="https://game.gtimg.cn/images/js/milo-utils/eruda/3.0.0/eruda.js"></script><script>eruda.init();</script>');
    // @ts-ignore
    loadScript('https://game.gtimg.cn/images/js/milo-utils/eruda/3.0.0/eruda.js').then(() => eruda.init());
}

const OLog = {
    log: console.log,
    info: console.info,
    warn: console.warn,
    error: console.error,
    debug: console.debug,
};

const OLogStyle = {
    debug: 'background: #eee; padding: 5px;',
    log: 'background: #ccc; font-weight: bold; padding: 5px;',
    info: 'background: #0099ff; color:white; font-weight: bold; padding: 5px;',
    warn: 'background: #ff9900; color:white; font-weight: bold; padding: 5px;',
};

function log(type: keyof typeof OLog, str: any, ...args: any[]) {
    if (type !== 'error' && OLogStyle[type] && typeof str === 'string' && /\[\s*Act/i.test(str)) {
        str = '%c' + str;
        args.unshift(OLogStyle[type]);
    }
    OLog[type].apply(console, [str, ...args]);
}

if (!isProductEnv()) {
    for (const type of ['log', 'info', 'warn', 'error', 'debug']) {
        console[type] = function (str: string, ...args: any[]) {
            return log(type as any, str, ...args);
        };
    }
}
